import { createFileRoute } from "@tanstack/react-router";

import { MirrorPage } from "@/components/MirrorPage";
import { content } from "@/mirror/page/privacy-employees";
import { requireUnlockedHome } from "@/lib/gate.functions";
import { mirrorHead } from "@/mirror/pages";

export const Route = createFileRoute("/privacy/employees")({
  loader: () => requireUnlockedHome(),
  head: () => mirrorHead("privacy-employees"),
  component: () => <MirrorPage key="privacy-employees" slug="privacy-employees" content={content} />,
});
